<label class="toggle">
  <input
    type="checkbox"
    [checked]="active"
    [disabled]="disabled"
    (change)="toggle()"
  />
  <span class="slider"></span>
  <span class="label" [innerHTML]="label"></span>
</label>
